import { TableRow } from "../../../../components/table-components/TableRow";
import { TableCellLink } from "../../../../components/table-components/TableCellLink";
import { routes } from "../../../../appRoutingHelpers";
import * as authSelectors from "../../../auth/authSelectors";
import { StyledText } from "../../../../assets/typography/typography";
import { colors } from "../../../../components/colors";
import { UserOrder } from "../../../shop/model/OrderSuccessResponse";
import {
  formatDateWithTime,
  formatMoneyAmount,
  formatOrderState,
  formatOrderStateBgColor,
  formatOrderStateTextColor,
} from "../../../../util";
import { InLineLabel } from "../../../../components/Label";
import { useSelector } from "react-redux";

type Props = {
  order: UserOrder;
};

export const UserOrderRow = ({ order }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const href = routes.orderShow(organizationKeyName, order.id);
  const labelBackgroundColor = formatOrderStateBgColor(order.state);
  const labelTextColor = formatOrderStateTextColor(order.state);
  const labelText = formatOrderState(order.state, order.deliveryType);

  return (
    <TableRow>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order.displayId}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order.shop.title}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order?.placedAt ? formatDateWithTime(order?.placedAt) : "-"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {order.deliveryType}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <InLineLabel
          backgroundColor={labelBackgroundColor}
          color={labelTextColor}
        >
          {labelText}
        </InLineLabel>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {formatMoneyAmount(order.total.amount, order.total.currency)}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};
